import React from "react";
import PageContainer from "../../../components/PageContainer/PageContainer";
import TwoColumnLayout from "../../../components/TwoColumnLayout/TwoColumnLayout";
import { Button, colors } from "@repo/ui";
import { useMediaQuery } from "react-responsive";
import EventDetails from "../components/AsideSection/EventDetails";
import undoIcon from "../../../assets/icons/undo.svg";
import { useNavigate } from "react-router-dom";
import TabNavigation from "../../../components/TabNavigation/TabNavigation";
import EditTableContent from "../components/EditTableContent";
import BackButton from "../../../components/BackButton";
import { useTranslation } from "react-i18next";
import { withTranslations } from "../../../hoc/withTranslations/withTranslations";

const LOCALE = "modules_MyGiftTable_pages_EditTable";

const EditTableWeb: React.FC = () => {
  const { t } = useTranslation(LOCALE);
  const navigate = useNavigate();

  return (
    <PageContainer startColor={colors.background} endColor="white">
      <div className="p-0 md:p-8 w-[100vw]">
        <TwoColumnLayout
          aside={
            <>
              <EventDetails />
              <Button
                className="w-full"
                label={
                  <div className="flex items-center justify-between">
                    <span>{t("backToMyTable")}</span>
                    <img
                      src={undoIcon}
                      alt={t("backToMyTableAlt")}
                      className="ml-2 h-4 w-4"
                    />
                  </div>
                }
                type="secondary"
                onClick={() => navigate("/my-table")}
              />
            </>
          }
          asideWidth="clamp(300px, 15vw, 10%)"
        >
          <TabNavigation
            tabs={[
              { label: t("editMyTable"), component: <EditTableContent /> },
            ]}
            stickyOffset={0}
          />
        </TwoColumnLayout>
      </div>
    </PageContainer>
  );
};

const EditTableMobile: React.FC = () => {
  const { t } = useTranslation(LOCALE);
  return (
    <PageContainer startColor={colors.background} endColor="white">
      <div className="flex flex-col p-0 w-screen">
        <div className="flex items-center p-4">
          <BackButton text={t("backButton")} />
        </div>
        <main className="flex-1 w-screen">
          <TabNavigation
            tabs={[
              { label: t("editMyTable"), component: <EditTableContent /> },
            ]}
          />
        </main>
      </div>
    </PageContainer>
  );
};

const EditTable: React.FC = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  return isMobile ? <EditTableMobile /> : <EditTableWeb />;
};

export default withTranslations(LOCALE)(EditTable);
